export default "__VITE_ASSET__CgiKB1Rc__"